import NotificationsList from "../views/NotificationsList"

export default [
	{
		path: "/:tenantId/notifications",
		component: NotificationsList,
		name: "NotificationsList",
		meta: { featureId: "notifications" },
		props: true
	}
]
